import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Cookies from 'js-cookie';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import Skeleton from '@material-ui/lab/Skeleton';
import IconButton from '@material-ui/core/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
    Box,
    Tooltip
} from '@mui/material';

import api from '../../../../../services/api';
import NavegadorGestao from "../../../../../components/NavBarGestao";
import {
    MaterialReactTable,

} from 'material-react-table';
import { Button } from "@material-ui/core";


import {
    DataGrid, 
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';




function novoProcedimento() {
    window.location.href = "/gestao/operacional/procedimentos/cadastrar"

}

export default function Procedimentos() {



    const [loading, setLoading] = useState(true);
    const [procedimentos, setProcedimentos] = useState([]);






    async function listarProcedimentos() {

        setLoading(true);

        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            await api.get("v1/protected/procedimentos/listartodos", {
                headers: headers
            }).then(function (response) {
                setProcedimentos(response.data)

                setLoading(false);

            });


        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar Procedimentos: " + _err)

        }

    }


    useEffect(() => {




        listarProcedimentos();


    }, []);




    const handleCellClick = (param, event) => {
        event.stopPropagation();
    };

    const handleRowClick = (param, event) => {
        event.stopPropagation();
    };

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport />
            </GridToolbarContainer>
        );
    }



    const handleClickVizualizar = ( objeto  ) => {


        window.location.href = "/gestao/operacional/procedimentos/vizualizar/" + objeto.id_procedimento;


    };


 


    const columnsMRT = [
        {
            id: 'acoes',
            header: 'Ações',
            size: 100,
            enableColumnFilter: false,
            enableSorting: false,
            Cell: ({ row }) => (
                <Tooltip title="Visualizar">
                    <IconButton
                        color="primary"
                        onClick={(event) => handleClickVizualizar(row.original)}
                    >
                        <VisibilityIcon />
                    </IconButton>
                </Tooltip>
            ),
        },
        {
            id: 'id_procedimento',
            header: 'ID',
            size: 50,
            accessorFn: row => row.id_procedimento,
            enableColumnFilter: true,
            filterFn: 'equals',
        },
        {
            id: 'area',
            header: 'Área',
            size: 150,
            accessorFn: row => row.area,
            enableColumnFilter: true,
            filterFn: 'includes',
            Cell: ({ renderedCellValue }) => {
                let text = '';
                switch (renderedCellValue) {
                    case 0: text = 'ORDEM DE SERVIÇO'; break;
                    case 1: text = 'ORDEM DE COMPRAS'; break;
                    case 20: text = 'RECURSOS HUMANOS'; break;
                    case 30: text = 'RECURSOS FINANCEIROS'; break;
                    case 40: text = 'RONDAS VIRTUAIS'; break;
                    default: text = '';
                }
                return <Typography variant="body2">{text}</Typography>;
            },
        },
        {
            id: 'tipo',
            header: 'Tipo',
            size: 100,
            accessorFn: row => row.tipo,
            enableColumnFilter: true,
            filterFn: 'includes',
            Cell: ({ renderedCellValue }) => {
                let text = '';
                switch (renderedCellValue) {
                    case 0: text = 'Ánalise'; break;
                    case 1: text = 'Implementação'; break;
                    default: text = '';
                }
                return <Typography variant="body2">{text}</Typography>;
            },
        },
        {
            id: 'etapa',
            header: 'Etapa',
            size: 150,
            accessorFn: row => row.etapa,
            enableColumnFilter: true,
            filterFn: 'includes',
            Cell: ({ renderedCellValue }) => {
                let text = '';
                switch (renderedCellValue) {
                    case 1: text = 'Tratamento Remoto'; break;
                    case 2: text = 'Ánalise Prévia'; break;
                    case 3: text = 'Tratamento em Campo'; break;
                    default: text = '';
                }
                return <Typography variant="body2">{text}</Typography>;
            },
        },
        {
            id: 'nome',
            header: 'Nome',
            size: 250,
            accessorFn: row => row.nome,
            enableColumnFilter: true,
            filterFn: 'includes',
            Cell: ({ renderedCellValue }) => (
                <Typography variant="body2" sx={{ color: 'black' }}>
                    {renderedCellValue || ''}
                </Typography>
            ),
        },
        {
            id: 'descricao_geral',
            header: 'Descrição',
            size: 350,
            accessorFn: row => row.descricao_geral,
            enableColumnFilter: true,
            filterFn: 'includes',
            Cell: ({ renderedCellValue }) => (
                <Typography variant="body2" sx={{ color: 'black' }}>
                    {renderedCellValue || ''}
                </Typography>
            ),
        },
        {
            id: 'usuario_criador',
            header: 'Criador',
            size: 350,
            accessorFn: row => ({
                usuario: row.usuario_criador?.nome_amigavel || '',
                data_criacao: row.data_hora_criacao,
            }),
            enableColumnFilter: true,
            filterFn: (row, columnId, filterValue) => {
                if (!filterValue) return true;
                const termo = filterValue.toLowerCase();
                const value = row.getValue(columnId);
                return value.usuario.toLowerCase().includes(termo);
            },
            Cell: ({ renderedCellValue }) => {
                const { usuario, data_criacao } = renderedCellValue;
                const formattedDate = moment(data_criacao).format('DD/MM/YYYY HH:mm');
                return (
                    <Typography variant="body2">
                        Criado por <strong>{usuario}</strong> em {formattedDate}
                    </Typography>
                );
            },
        },
        {
            id: 'exigir_comprovacao',
            header: 'Exigir Comprovação',
            size: 100,
            accessorFn: row => row.exigir_comprovacao,
            enableColumnFilter: true,
            filterFn: 'includes',
            Cell: ({ renderedCellValue }) => {
                const text = renderedCellValue === 1 ? 'SIM' : 'NÃO';
                return <Typography variant="body2">{text}</Typography>;
            },
        },
    ];

    return (
        <div>

            <NavegadorGestao
                Operacional={true}
                Procedimentos={true}
                corFundo={'white'} travado={true} corTexto={'black'}
            />

            <div style={{ padding: 5 }}>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="center"
                    item xs={12}
                >
                    <Button style={{ margin: 5 }}
                        variant="contained"
                        color="primary"
                        onClick={novoProcedimento}
                    >
                        Novo Procedimento
                    </Button>
                </Grid>
                {loading ?
                    <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
                    </Skeleton>
                    :

                    <Box

                    >

                        <Box sx={{
                            flexGrow: 1,
                            overflow: 'auto',
                        }}>
                            <MaterialReactTable
                                columns={columnsMRT}
                                data={procedimentos}
                                enableBottomToolbar
                                enableGlobalFilterModes
                                enableRowActions
                                enableStickyHeader
                                paginationDisplayMode="pages"
                                getRowId={(row) => row.id_procedimento}
                                enableGrouping
                                enableFullScreenToggle
                                initialState={{
                                    showGlobalFilter: true,

                                    showColumnFilters: true,
                                }}
                                muiTableContainerProps={{
                                    sx: {
                                        maxHeight: 'calc(100vh - 250px)', // ajuste 200px conforme altura do topo/botões
                                    },
                                }}
                                muiTableHeadCellProps={{
                                    sx: {
                                        padding: '2px',       // reduz o espaçamento interno
                                        fontSize: '0.75rem',  // fonte menor
                                        lineHeight: 1,
                                        height: '24px',       // altura do cabeçalho
                                    },
                                }}
                                muiTableBodyCellProps={{
                                    sx: {
                                        padding: '5px',
                                        fontSize: '0.75rem',
                                        lineHeight: 2,
                                    },
                                }}


                                muiPaginationProps={{
                                    rowsPerPageOptions: [100, 200, 400],
                                    variant: 'outlined',
                                }}

                            />
                        </Box>
                    </Box>

                }


            </div>


        </div>
    );
}



